import React from 'react';
import { motion } from 'framer-motion';
export const OpeningLead = () => {
  return <section className="w-full bg-white py-16 px-4 md:py-24" data-id="element-108">
      <div className="max-w-2xl mx-auto space-y-8 text-lg md:text-xl leading-relaxed text-[#2D3436]" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-110">
          <p className="font-serif text-2xl md:text-3xl text-[#1B2A4A] font-medium mb-8" data-id="element-111">
            Hay un tipo de miedo que no se siente como pánico.
          </p>

          <p className="mb-6" data-id="element-112">
            Se siente como volver a ver el mismo video en tu teléfono… otra vez.
          </p>

          <p className="mb-6" data-id="element-113">Como contar “cuántas veces respondió” hoy.</p>

          <p className="mb-6" data-id="element-114">
            Como decirte:{' '}
            <span className="italic text-[#1B2A4A]" data-id="element-115">
              “seguro estoy exagerando”
            </span>
            … y al minuto siguiente pensar:{' '}
            <span className="italic text-[#1B2A4A]" data-id="element-116">“¿y si no?”</span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#FFF9F3] p-8 rounded-2xl border-l-4 border-[#E8734A] my-8" data-id="element-117">
          <p className="font-bold text-[#1B2A4A] mb-4" data-id="element-118">
            Y lo peor no es la duda.
          </p>
          <p className="mb-4" data-id="element-119">
            Lo peor es esto: no saber qué hacer mañana sin caer en dos extremos:
          </p>
          <ol className="list-decimal pl-5 space-y-2 mb-4" data-id="element-120">
            <li data-id="element-121">Volverte detective 24/7, o</li>
            <li data-id="element-122">Esperar meses con esa ansiedad instalada en el pecho.</li>
          </ol>
          <p className="font-semibold text-[#E8734A]" data-id="element-123">
            La Ruta Clara existe para ese momento.
          </p>
        </motion.div>
      </div>
    </section>;
};